/** 値の変換、型変換に関するメソッドをまとめるクラス */
export class UtilType {

  /** nullチェック
   * @param {string | number | boolean} value nullチェックする値
   * @param {string} expectType 期待する型
   * @param {any} setSpecifiedValue nullだった場合に代入する値
   * @return {any} value = null だった場合、特定の値に変換される
  */
 checkNull(value: string | number | boolean, expectType: string, setSpecifiedValue: any = null): any {
    switch (expectType) {
      case 'string':
        if (value === null || value === undefined) {
          setSpecifiedValue === null ? value = '' : value = setSpecifiedValue;
        }
        break;
      case 'number':
        if (value === null || value === undefined) {
          setSpecifiedValue === null ? value = 0 : value = setSpecifiedValue;
        }
        break;
      case 'boolean':
        if (value === null || value === undefined) {
          setSpecifiedValue === null ? value = false : value = setSpecifiedValue;
        }
        break;
      default:
        break;
    }
    return value;
  }

  /** 配列内にある連想配列のキー('targetKey')に対応する値を'beforeVal'から'afterVal'に変換 */
  changeValuesInArray(array: any[], targetKey: string[], beforeVal: any, afterVal: any) {
    return array.map(function(res) {
      for (const key of targetKey) {
        if (key in res && res[key] === beforeVal) {
          res[key] = afterVal;
        }
      }
      return res;
    });
  }

  replaceNewLineCodeToBRTag(string: string): string {
    const regExp = new RegExp('\\n', 'g');
    return string = string.replace(regExp, '<br>');
  }

  replaceBrTagToNewLineCode(string: string): string {
    const regExp = new RegExp('<br>', 'g');
    return string = string.replace(regExp, '\n');
  }

  /** 小文字の英字を全て大文字に変換 */
  toUpperCase(str: string): string {
    if (!str) {
      return;
    }
    return str.toUpperCase();
  }

  /** trim()で空白を除去する。文字列型以外の場合は引数の値をそのままreturn
   * @param str trim()対象文字列
   */
  checkAndTrim(str: string): string {
    if (typeof(str) !== 'string') {
      return str;
    }
    str = str.trim();
    return str;
  }

  /** クエリパラメータ用に値を変換する。 */
  public static convertBlankAsQueryParams(object: any): any {
    const obj = JSON.parse(JSON.stringify(object));
    for (let key of Object.keys(obj)) {
      if (obj[key] === null || obj[key] === undefined) {
        obj[key] = '';
      }
    }
    return obj;
  }
}
